/**
 * GET /chat/document-export-suggestions — personalized export CTA copy for one session document.
 */
import { useAuthToken } from '@/hooks/useAuthToken';
import { isChatDocumentExportSuggestionsApiAvailable } from '@/utils/backendSurfaces';
import type { components } from '@heidi/schema/ml-scribe';
import { useQueryDocumentExportSuggestions as useQueryDocumentExportSuggestionsCore } from '@heidi/session/data';

export type DocumentExportSuggestionResponse =
  components['schemas']['DocumentExportSuggestionResponse'];

interface UseQueryDocumentExportSuggestionsOptions {
  sessionId: string;
  documentId: string | null | undefined;
  enabled?: boolean;
}

export function useQueryDocumentExportSuggestions({
  sessionId,
  documentId,
  enabled = true,
}: UseQueryDocumentExportSuggestionsOptions) {
  const token = useAuthToken();

  return useQueryDocumentExportSuggestionsCore({
    sessionId,
    documentId,
    enabled:
      isChatDocumentExportSuggestionsApiAvailable &&
      Boolean(token && sessionId && documentId && enabled),
  });
}
